import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataDoneAction, loadDataErrorAction } from 'modules/app/actions';
import { getDocs } from '../actions';
import { GET_DOCS } from '../constants/actionTypes';
import * as api from '../repository';


function *_fetchDocs(action) {
    const {trac} = action;
    yield put(loadDataAction('docs'));
    try {
        const docs =  yield call(api.getDocs(trac));
        yield put(getDocs.success({docs, utrac:trac}));
        yield put(loadDataDoneAction('docs'));
    } catch (error) {
        yield put(getDocs.error(error));
        yield put(loadDataErrorAction('docs', {response: error.response}, action));
    }
}

export function *fetchDocs() {
    yield takeEvery(GET_DOCS.REQUEST, _fetchDocs);
}
